import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

export default {
  post(payload, assigned = false) {
    const endpoint = assigned ? 'donorContactAssigned' : 'donorContact'
    return http.post(endpoints.get(endpoint, { ...payload }), payload.data)
  },
  get(payload, assigned = false) {
    const endpoint = assigned ? 'getDonorContactAssigned' : 'getDonorContact'
    return http.get(endpoints.get(endpoint, { ...payload }))
  }
}
